<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <ng-container *ngIf="contentHeader">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-lg-8">
              <h2 class="content-header-title mb-0">{{ contentHeader.headerTitle | translate }}</h2>
              <app-breadcrumb *ngIf="contentHeader?.breadcrumb?.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
            </div>
            <div class="col-lg-4 text-right pt-1">
              <button class="btn btn-primary" (click)="syncInvoices()">{{ 'SYNC_INVOICES' |translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ngb-alert *ngIf="invoices_with_errors.length" [type]="'danger'" [dismissible]="true" class="card w-100 m-0 active mb-2">
      <h4 class="alert-heading py-1">{{ 'INVOICES_SYNC_WITH_ERROR' | translate }} </h4>
      <section class="px-1 alert-body">
        <p>{{ 'INVOICES_WITH_THESE_IDS_ARE_IN_ERROR' | translate }}</p>
        <ul>
          <li *ngFor="let fc of invoices_with_errors">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>

    <ngb-alert *ngIf="invoices_not_found.length" [type]="'danger'" [dismissible]="true" class="card w-100 m-0 active mb-2">
      <h4 class="alert-heading py-1">{{ 'INVOICES_SYNC_NOT_FOUND' | translate }} </h4>
      <section class="px-1 alert-body">
        <p>{{ 'INVOICES_NOT_FOUND' | translate }}</p>
        <ul>
          <li *ngFor="let fc of invoices_not_found">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>

    <ngb-alert *ngIf="invoices_duplicated.length" [type]="'danger'" [dismissible]="true" class="card w-100 m-0 active mb-2">
      <h4 class="alert-heading py-1">{{ 'INVOICES_SYNC_DUPLICATED' | translate }} </h4>
      <section class="px-1 alert-body">
        <p>{{ 'INVOICES_DUPLICATED' | translate }}</p>
        <ul>
          <li *ngFor="let fc of invoices_duplicated">{{ fc }}</li>
        </ul>
      </section>
    </ngb-alert>

    <div class="card">
      <div class="card-title w-100 p-2 mb-0">
        <div class="row">
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filter()" />
          </div>
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select class="mr-1" [(ngModel)]="filterStatus" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filter()">
              <ng-option value="all">
                <span class="font-small-4 font-weight-normal pr-2">{{ "STATE_INVOICE" | translate }}</span>
              </ng-option>
              <ng-option value="waiting">
                <span class="font-small-4 font-weight-normal pr-2">{{ "WAITING" | translate }}</span>
              </ng-option>
              <ng-option value="not_processed">
                <span class="font-small-4 font-weight-normal pr-2">{{ "NOT_PROCESSED" | translate }}</span>
              </ng-option>
              <ng-option value="processing">
                <span class="font-small-4 font-weight-normal pr-2">{{ "PROCESSING" | translate }}</span>
              </ng-option>
              <ng-option value="processed">
                <span class="font-small-4 font-weight-normal pr-2">{{ "PROCESSED" | translate }}</span>
              </ng-option>
              <ng-option value="failed">
                <span class="font-small-4 font-weight-normal pr-2">{{ "FAILED" | translate }}</span>
              </ng-option>
              <ng-option value="success">
                <span class="font-small-4 font-weight-normal pr-2">{{ "SUCCESS" | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12 pl-0" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filterCustomer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="filter()">
              <ng-option [value]="0">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
              </ng-option>
              <ng-option [value]="customer.id" *ngFor="let customer of customers">
                <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 text-right" [ngClass.sm]="'col-12 mt-1'">
            <div [ngClass.xl]="'d-inline-block'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body px-0 py-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 150"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredListElements"
        >
          <ngx-datatable-column [name]="'ID' | translate" prop="order_number" [width]="50" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.id }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ORDER_NUMBER' | translate" prop="order_number" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.order_number }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="client.name" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DOCUMENT_DATE' | translate" prop="document_date" [width]="120" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.document_date | date: "dd/MM/yyyy" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'AMOUNT' | translate" prop="total_amount" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.invoice_type.name.toLowerCase().includes('di credito') ? '-' : '' }}{{ row.total_amount | currency: "EUR" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RESOURCES' | translate" [width]="80" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
                <span *ngIf="row.users_in_rows?.length == 1" [ngbTooltip]="(row.users_in_rows || []).join(', ')">
                    <i [data-feather]="'user'" size="19"></i>
                </span>
              <span *ngIf="row.users_in_rows?.length > 1" [ngbTooltip]="(row.users_in_rows || []).join(', ')">
                    <i [data-feather]="'users'" size="19"></i>
                </span>
              <span *ngIf="row.products_in_rows?.length > 0" [ngbTooltip]="(row.products_in_rows || []).join(', ')">
                    <i [data-feather]="'package'" size="19"></i>
                </span>
              <span *ngIf="row.users_in_rows.length < 1 && row.products_in_rows.length < 1" [ngbTooltip]="row.rows[0].description">
                  <i [data-feather]="'info'" size="19"></i>
                </span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE' | translate" [width]="150" prop="status" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="badge badge-pill" [ngClass]="{
                'badge-warning': row.status==='processing' || row.status==='processed' || row.status==='waiting',
                'badge-danger': row.status==='failed'
              }">{{ row.status_note || (row.status.toUpperCase() | translate) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [width]="50" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center justify-content-center">
                <button class="btn bg-transparent pl-05 pr-05" type="button" (click)="invoiceSelectedId = row.id" [ngbTooltip]="'VIEW' | translate" placement="left" has_capability="view_invoice_detail">
                  <i class="text-primary" [data-feather]="'eye'" size="19"></i>
                </button>
                <button class="btn bg-transparent pl-05 pr-05" type="button" [ngbTooltip]="'CANCEL_SENDING' | translate" placement="left" has_capability="view_invoice_detail" (click)="setStatusNotProcessed(row.id)">
                  <i class="text-primary" [data-feather]="'rotate-ccw'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" [width]="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DOCUMENT_NUMBER" | translate }}: </span>
                  <span>{{ row.document_number }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "CUSTOMER" | translate }}: </span>
                  <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DOCUMENT_DATE" | translate }}: </span>
                  <span>{{ row.document_date | date: "dd/MM/yyyy" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "AMOUNT" | translate }}: </span>
                  <span>{{ row.total_amount | currency: "EUR" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                  <span class="badge badge-pill" [ngClass]="{
                'badge-warning': row.status==='processing' || row.status==='processed',
                'badge-success': row.status==='success',
                'badge-danger': row.status==='failed'
              }">{{ row.status_note || (row.status.toUpperCase() | translate) }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <h4 class="px-2 py-1">{{ 'SUM_ESTIMATED_REVENUE' | translate }}: {{ sumTotalsAmount | currency: 'EUR' }}</h4>
      </div>
    </div>
  </div>
</div>
<app-invoice-modal-detail [invoiceId]="invoiceSelectedId" *ngIf="!!invoiceSelectedId" (onclose)="invoiceSelectedId = null"></app-invoice-modal-detail>
